class ProductCard extends HTMLElement {
 constructor() {
   super();


   this.productUrl = null;
 }


 connectedCallback() {
   this.productUrl = this.dataset.productUrl;


   this.addEventListener('click', this.handleClick);
 }


 disconnectedCallback() {
   this.removeEventListener('click', this.handleClick);
 }


 handleClick = (event) => {
   if (event.target instanceof Element) {
     const interactiveElement = event.target.closest(
       'button, input, label, select, [tabindex="1"], a, quick-add-component, add-to-wishlist-button',
     );
     if (interactiveElement) return;
   }


   // Cherche d'abord un vrai lien produit dans la carte
   const productLink = this.querySelector('a[href*="/products/"]');


   if (productLink && productLink.href) {
     window.location.href = productLink.href;
     return;
   }


   // Fallback si aucun lien produit n'est trouvé
   if (this.productUrl) {
     window.location.href = this.productUrl;
   }
 };
}


if (!customElements.get('product-card')) {
 customElements.define('product-card', ProductCard);
}
